// Constants shared by Studio's editor and anywhere its blocks render

// Elements inside a block that pressing mustn't start a grid drag from
export const NO_DRAG_CLASS = 'studio-no-drag';

// Whether Studio offers Grouped (Composite) blocks to make: in the palette,
// a block's type, Shift/Cmd-click merging, the agent and the guide. Off for
// now: Grouped blocks already made still draw and edit as before.
export const IS_GROUPED_LAYOUT_OFFERED = false;

// Gadget types Studio doesn't offer to make for now: in the palette, a
// block's (or Grouped element's) type, or the agent. Blocks already of one
// still draw and edit as before, and keep it listed as their type.
export const UNOFFERED_VIS_TYPES: Studio.VisType[] = ['pictorialBar'];

// Marks a Composite element's cell with its id, so the canvas can tell which
// element a sidebar drag is over
export const STUDIO_ELEMENT_ID_ATTR = 'data-studio-element-id';

// Marks a Composite row with its id, so the canvas can tell which row a
// sidebar drag is over; dropped between its elements (or after them), the
// metric or vis type becomes a new element there
export const STUDIO_ROW_ID_ATTR = 'data-studio-row-id';

// Marks the "New row" slot shown below a Composite at the same time, with the
// block's id (the slot sits outside the block, over the grid squares below
// it); dropped there, the metric or vis type becomes a new row of the block
export const STUDIO_ADD_ROW_CARD_ATTR = 'data-studio-add-row-card';

// Marks a Composite block with its id, so the canvas can measure it (and
// its rows and cells) to tell where a sidebar drag over it goes (see
// compositeDropTarget)
export const STUDIO_COMPOSITE_CARD_ATTR = 'data-studio-composite-card';

// How tall a Composite's "New row" slot is, hanging below it: a sidebar drag
// there still goes in the block (see compositeDropTarget)
export const COMPOSITE_NEW_ROW_SLOT_HEIGHT = 32;

// Composite header dot colours, from the chart palette
export const ACCENT_IDS: Studio.AccentId[] = [
  'chart-1',
  'chart-2',
  'chart-3',
  'chart-4',
  'chart-5',
  'chart-6',
  'chart-7',
  'chart-8',
];
export const DEFAULT_ACCENT: Studio.AccentId = 'chart-1';
export const NO_ACCENT = 'none';
export const toAccentCss = (accent: Studio.AccentId | undefined): string =>
  `var(--color-${accent ?? DEFAULT_ACCENT})`;
// A Composite header's dot colour; undefined for no dot
export const toAccentColor = (
  accent: Studio.AccentSetting | undefined,
): string | undefined =>
  accent === NO_ACCENT ? undefined : toAccentCss(accent);

// The largest a Number's value is drawn on a canvas, dashboard or report
// (fullscreen draws it larger, see getFullscreenValueFontSize)
export const MAX_VALUE_FONT_SIZE = 25;

// The largest a Number block's value can be at this pixel size; it shrinks
// from there to fit beside its captions (useFittedFontSize)
export const getValueFontSize = ({
  width,
  height,
}: {
  width: number;
  height: number;
}): number =>
  Math.round(
    Math.max(16, Math.min(height * 0.32, width * 0.16, MAX_VALUE_FONT_SIZE)),
  );
